/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（木曜日）
 * @export
 * @interface EnableArrivalThu
 */
export interface EnableArrivalThu {
}

/**
 * Check if a given object implements the EnableArrivalThu interface.
 */
export function instanceOfEnableArrivalThu(value: object): value is EnableArrivalThu {
    return true;
}

export function EnableArrivalThuFromJSON(json: any): EnableArrivalThu {
    return EnableArrivalThuFromJSONTyped(json, false);
}

export function EnableArrivalThuFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalThu {
    return json;
}

export function EnableArrivalThuToJSON(json: any): EnableArrivalThu {
    return EnableArrivalThuToJSONTyped(json, false);
}

export function EnableArrivalThuToJSONTyped(value?: EnableArrivalThu | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

